import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { isTokenExpired } from "../helper/helper_functions";
import { DynamicContext } from "./DynamicContext";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { sessionExpired, setSessionExpired } = useContext(DynamicContext);
  const location = useLocation();

  useEffect(() => {
    const checkAuthStatus = () => {
      const publicRoutes = [
        "/login",
        "/",
        "/signup",
        "/forgot-password",
        "/admin-signup",
        "/member-signup",
        "/select-plan",
      ];

      if (
        publicRoutes.includes(location.pathname) ||
        location.pathname.startsWith("/board/") ||
        location.pathname.startsWith("/job/view/")
      ) {
        setSessionExpired(false);
        return;
      }
      // const token = localStorage.getItem("token");
      // const tokenExpiry = localStorage.getItem("tokenExpiry");
      // const refreshToken = Cookies.get("refreshToken");
      const refreshTokenExpiry = Cookies.get("refreshTokenExpiry");
      const sessionExpiredFlag =
        localStorage.getItem("sessionExpired") === "true";
      // console.log("Auth check:", {
      //   hasToken: !!token,
      //   tokenExpired: tokenExpiry ? isTokenExpired(tokenExpiry) : true,
      //   hasRefreshToken: !!refreshToken,
      //   refreshTokenExpired: refreshTokenExpiry ? isTokenExpired(refreshTokenExpiry) : true,
      //   sessionExpiredFlag,
      // });
      if (sessionExpiredFlag) {
        setSessionExpired(true);
        return;
      }
      if (refreshTokenExpiry && isTokenExpired(refreshTokenExpiry)) {
        localStorage.setItem("sessionExpired", "true");
        setSessionExpired(true);
        return;
      }
      setSessionExpired(false);
    };

    checkAuthStatus();
    const interval = setInterval(checkAuthStatus, 30000);
    return () => clearInterval(interval);
  }, [location.pathname]);

  useEffect(() => {
    const handler = () => setSessionExpired(true);
    window.addEventListener("session-expired", handler);
    return () => window.removeEventListener("session-expired", handler);
  }, []);

  return (
    <AuthContext.Provider value={{ sessionExpired, setSessionExpired }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
